export default __webpack_public_path__ + "static/psle-slay-f36e48084c2f0ed6071dd57c8c24b96b.png";